import { render, staticRenderFns } from "./DeptInventoryList.vue?vue&type=template&id=7375d1c6&"
import script from "./DeptInventoryList.vue?vue&type=script&lang=js&"
export * from "./DeptInventoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports